<template>
<div class="tw-relative">
    <div class="sm:tw-flex sm:tw-space-x-6 tw-sticky tw-top-0 tw-z-20 tw-bg-white tw-py-6 tw-border-b">
        <slot name="header"></slot>

        <div class="tw-flex tw-items-center tw-space-x-2 tw-w-full">
            <i class="fa fa-search tw-text-gray-400 tw-text-xl"></i>

            <div class="tw-relative tw-w-full">
                <input type="text" class="form-control" placeholder="Search this list" spellcheck="false" @input="findSuggestions($event.target.value)">

                <ul v-show="displaySuggestions" class="tw-absolute tw-bg-white tw-shadow tw-w-full tw-z-20 tw-overflow-auto" ref="suggestions" name="suggestions" style="max-height: 200px">
                    <slot name="suggestions"></slot>
                    <li v-show="noMatches" class="tw-p-3 tw-text-gray-400">No Matches</li>
                </ul>
            </div>
        </div>
    </div>

    <div ref="items">
        <slot></slot>
    </div>
</div>
</template>

<script>
export default {
    name: "SearchList",

    data() {
        return {
            suggestions: [],
            items: {},
            displaySuggestions: false,
            noMatches: false,
        }
    },

    mounted() {
        this.setup();
        
        document.addEventListener('click', event => {
            if(event.target.closest('[name=suggestions]')) {
                this.displaySuggestions = false;
            }
        });
    },

    methods: {
        setup() {
            // Grab the list items
            let children = this.$refs.items.querySelectorAll('[data-search-value]');

            for(let child of children) {
                this.items[child.dataset.searchValue] = child;
            }
            
            // Grab the search suggestions
            this.suggestions = Array.from(this.$refs.suggestions.querySelectorAll('li'));
            this.suggestions.pop();

            // Apply styles and event listeners to all but the last li
            for(let x = 0; x < this.suggestions.length; x++) {
                this.suggestions[x].classList.add('tw-p-3', 'hover:tw-bg-gray-200', 'tw-cursor-default', 'tw-hidden');

                this.suggestions[x].addEventListener('click', event => this.scrollTo(event.target.innerHTML));
            }
            
        },

        findSuggestions(input) {
            this.clearStyling();
            
            if(input != "") {
                let searchKeywords = input.split(" ");

                this.displaySuggestions = true;
                this.noMatches = false;
                let matches = false;
                
                for(let suggestion of this.suggestions) {
                    let participantName = suggestion.innerHTML.split(" ");
                    let matchingKeywords = [];

                    // Each search keyword needs to match at least one name from the participant name
                    // Every search keyword other than the last one needs to match exactly
                    searchKeywords.forEach((keyword, index) => {
                        console.log(keyword, index);
                        if(index == (searchKeywords.length - 1)) {
                            // Last keyword, only needs to match the beginning of a name
                            for(let name of participantName) {
                                if(name.toLowerCase().startsWith(keyword.toLowerCase())) {
                                    matchingKeywords.push(keyword);
                                    break;
                                }
                            }
                        } else {
                            // Any keywords other than the last one need to match exactly
                            for(let name of participantName) {
                                if(name.toLowerCase() == keyword.toLowerCase()) {
                                    matchingKeywords.push(keyword);
                                    break;
                                }
                            }
                        }
                    })

                    // The participant name matches the search if every search keyword matched a name
                    let isMatch = matchingKeywords.length == searchKeywords.length;
    
                    // Show suggestions matching the search, hide ones that don't
                    suggestion.classList.toggle('tw-hidden', !isMatch);
    
                    if(isMatch) {
                        matches = true;
                    }
                }
    
                if(!matches) {
                    console.log('no matches');
                    this.noMatches = true;
                }
            } else {
                // If the input is empty, turn off the dropdown
                this.displaySuggestions = false;
            }
        },

        scrollTo(event) {
            console.log(event);

            this.items[event].style.outline = '2px solid #38BDF8';
            this.items[event].style.outlineOffset = '-2px';
            console.log(this.items[event].offsetTop);
            window.scrollTo({top: this.items[event].offsetTop, behavior: 'smooth'});

        },

        clearStyling() {
            for(let item of Object.keys(this.items)) {
                this.items[item].style.outline = 'none';
                this.items[item].style.outlineOffset = '0px';
            }
        }
    }
}
</script>
